import { z } from 'zod';
import i18n from '../i18n';

// Exercise Schema
export const exerciseSchema = z.object({
    id: z.string().optional(),
    instanceId: z.string().optional(),
    name: z.string().min(1, () => i18n.t('validation.exercise_name_required')).max(100, () => i18n.t('validation.exercise_name_too_long')),
    muscle: z.string().max(50).optional(),
    video: z.string().url(() => i18n.t('validation.invalid_video_url')).optional().or(z.literal('')),
    targets: z.record(z.any()).optional(), // Complex structure, keeping loose for now
    logs: z.record(z.any()).optional()
});

// Day Schema
export const daySchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, () => i18n.t('validation.day_name_required')).max(50, () => i18n.t('validation.day_name_too_long')),
    exercises: z.array(exerciseSchema)
});

// Block Schema
export const blockSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, () => i18n.t('validation.block_name_required')).max(50, () => i18n.t('validation.block_name_too_long')),
    weeks: z.number().min(1).max(12),
    days: z.array(daySchema),
    authorId: z.string().optional()
});

// Routine Schema
export const routineSchema = z.object({
    id: z.string().optional(),
    userId: z.string(),
    name: z.string().min(1, () => i18n.t('validation.routine_name_required')).max(100, () => i18n.t('validation.routine_name_too_long')),
    status: z.enum(['active', 'archived']).optional(),
    blocks: z.array(blockSchema),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional()
});

export const validateRoutine = (data) => {
    return routineSchema.safeParse(data);
};
// Auth Schemas
export const emailSchema = z.string().email(() => i18n.t('validation.invalid_email'));
export const passwordSchema = z.string()
    .min(6, () => i18n.t('validation.password_min_length'))
    .regex(/[A-Z]/, () => i18n.t('validation.password_uppercase'))
    .regex(/[^a-zA-Z0-9]/, () => i18n.t('validation.password_special_char'));

export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, () => i18n.t('validation.password_required')) // Login allows any password format, let Firebase check validity
});

export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema
});
